export default __webpack_public_path__ + "static/media/ponentes___Alicia Acosta.3fa0cc74.jpg";